import Header from "@/components/header/Header";
import { Outlet } from "@tanstack/react-router";
import { SyntheticEvent, useCallback } from "react";
import { useTheme } from "@/context/ThemeProvider";
import { BlockchainProvider } from "@/context/BlockchainContext";
import { cn } from "@/lib/utils";

/**
 * Authenticated shell: header + page outlet.
 * Wired from protected layout routes in `src/routing/routes/`.
 */
function MainLayout() {
  const { darkMode } = useTheme();

  const handleContextMenu = useCallback((event: SyntheticEvent) => {
    event.preventDefault();
  }, []);

  return (
    <BlockchainProvider>
      <div
        onContextMenu={handleContextMenu}
        className={cn(
          "fixed flex w-screen flex-col h-screen bg-mfpurple/5 dark:bg-gray-800 text-gray-800 dark:text-gray-100",
          darkMode && "dark"
        )}
      >
        <Header />
        <div className="flex flex-col grow shrink overflow-y-auto paragraph md:px-[20px] scrollbar-hide dark:bg-mfdarkbase">
          <Outlet />
        </div>
      </div>
    </BlockchainProvider>
  );
}

export default MainLayout;
